import { AttachmentFieldDefinition } from './attachment-definition'
import {
  AnyOfFieldDefinition,
  DateTimeFieldDefinition,
  DurationFieldDefinition,
  FieldDefinition,
  ListFieldDefinition,
  LookupFieldDefinition,
  NumericFieldDefinition,
  OptionsetFieldDefinition,
  StringFieldDefinition,
  TimeFieldDefinition,
} from './field-definitions'

export class DefinitionUtils {
  public static mapFieldDefinitions(fields: FieldDefinition[]): FieldDefinition[] {
    const mappedFields: FieldDefinition[] = []
    if (fields) {
      fields.forEach((f) => {
        const mappedField: FieldDefinition = this.mapFieldDefinition(f)
        mappedFields.push(mappedField)
      })
    }
    return mappedFields
  }

  public static mapFieldDefinition(f: FieldDefinition): FieldDefinition {
    let mappedField: FieldDefinition
    switch (f.fieldDefinitionType) {
      case 'String':
        mappedField = new StringFieldDefinition(f as StringFieldDefinition)
        break
      case 'Numeric':
        mappedField = new NumericFieldDefinition(f as NumericFieldDefinition)
        break
      case 'OptionSet':
        mappedField = new OptionsetFieldDefinition(f as OptionsetFieldDefinition)
        break
      case 'Lookup':
        mappedField = new LookupFieldDefinition(f as LookupFieldDefinition)
        break
      case 'DateTime':
        mappedField = new DateTimeFieldDefinition(f as DateTimeFieldDefinition)
        break
      case 'DateTimeUnknown':
        mappedField = new DateTimeFieldDefinition(f as DateTimeFieldDefinition)
        break
      case 'List':
        mappedField = new ListFieldDefinition(f as ListFieldDefinition)
        break
      case 'Attachment':
        mappedField = new AttachmentFieldDefinition(f as AttachmentFieldDefinition)
        break
      case 'Image':
        mappedField = new AttachmentFieldDefinition(f as AttachmentFieldDefinition)
        break
      case 'Bag':
        // FIXME check this field
        mappedField = new StringFieldDefinition(f as StringFieldDefinition)
        break
      case 'Duration':
        mappedField = new DurationFieldDefinition(f as DurationFieldDefinition)
        break
      case 'Time':
        mappedField = new TimeFieldDefinition(f as TimeFieldDefinition)
        break
      // StringFieldDefinition is only temporary for these two, the proper ones will be implemented
      case 'AnyOf':
        mappedField = new AnyOfFieldDefinition(f as AnyOfFieldDefinition)
        break
      case 'CodeableConcept':
        mappedField = new StringFieldDefinition(f as StringFieldDefinition)
        break
      default:
        throw new Error(`[EntityModel - mapFieldDefinitions] Unupported field: ${f.fieldDefinitionType}-${f.name}`)
    }
    return mappedField
  }
}
